import React from 'react';

export const SizeContext = React.createContext(() => {});
